"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireWildcard(require("../../libs/translationsUtils/phrase"));

var _GlobalClick = _interopRequireDefault(require("@insided/shared/uikit/GlobalClick"));

var _buttonControl = _interopRequireDefault(require("@insided/deprecated-preact-components/button-control"));

var _Button = _interopRequireDefault(require("@insided/deprecated-control/ui-components/Button"));

var _AttachmentList = _interopRequireDefault(require("@insided/shared/uikit/Editor/Attachments/AttachmentList"));

var _contentConverter = require("@insided/shared/uikit/Editor/contentConverter");

var _AttachmentUploader = _interopRequireWildcard(require("@insided/shared/uikit/Editor/Attachments/AttachmentUploader"));

var _ErrorList = _interopRequireDefault(require("@insided/shared/uikit/Editor/ErrorList"));

var _Poll = _interopRequireDefault(require("@insided/shared/uikit/Editor/Poll"));

var _classnames = _interopRequireDefault(require("classnames"));

var _AddTopicCardModal = _interopRequireDefault(require("@insided/shared/uikit/Editor/AddTopicCardModal"));

var _utils = require("@insided/shared/uikit/Editor/Attachments/utils");

var _utils2 = require("@insided/shared/uikit/Editor/utils");

var _observeMentions = require("@insided/shared/uikit/Editor/observeMentions");

var _UserContext = require("@insided/shared/services/UserContext");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EmojiSelector;
var CKEditor;
/**
 * @deprecated
 * ```
 * import Editor from '@insided/shared/uikit/Editor'
 * ```
 */

var Editor = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Editor, _Component);

  var _super = _createSuper(Editor);

  function Editor(props) {
    var _this$props$attachmen, _this$props$poll;

    var _this;

    (0, _classCallCheck2.default)(this, Editor);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      attachments: (_this$props$attachmen = _this.props.attachments) !== null && _this$props$attachmen !== void 0 && _this$props$attachmen.length ? (0, _utils.prepareAttachmentsForState)(_this.props.attachments) : [],
      attachmentErrors: [],
      editorErrors: [],
      attachmentToProcess: 0,
      imageToProcess: 0,
      editor: null,
      enablePoll: _this.props.poll != null,
      poll: (_this$props$poll = _this.props.poll) !== null && _this$props$poll !== void 0 ? _this$props$poll : {
        question: '',
        options: []
      },
      showTopicCardModal: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getEditorContent", function () {
      if (_this.editorContent === undefined) {
        return _this.initialData;
      }

      return _this.editorContent;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "attachmentError", function (filename, errorPhrase) {
      _this.setState(function (_ref) {
        var attachmentToProcess = _ref.attachmentToProcess,
            attachmentErrors = _ref.attachmentErrors;
        return {
          attachmentToProcess: attachmentToProcess - 1,
          attachmentErrors: attachmentErrors.concat({
            filename: filename,
            errorPhrase: errorPhrase
          })
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "uploadFile", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(file) {
        var uploadData, attachmentId;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                attachmentId = _this.attachmentUploader.getUniqueAttachmentId(); // Add empty attachment to show the loader

                _this.updateAttachments(_this.state.attachments.concat({
                  attachmentId: attachmentId,
                  source: '',
                  source_thumb: '',
                  type: _this.attachmentUploader.getType(file),
                  file_original_name: file.name,
                  file_size: file.size,
                  file_uuid: '',
                  url: '',
                  filename: file.name
                }));

                _context.prev = 2;
                _context.next = 5;
                return _this.attachmentUploader.uploadFile(attachmentId, file);

              case 5:
                uploadData = _context.sent;
                _context.next = 13;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](2);

                if (_context.t0 instanceof _AttachmentUploader.FileSizeError) {
                  _this.attachmentError(file.name, 'js.uploader.error_file_size');
                } else if (_context.t0 instanceof _AttachmentUploader.TotalFileSizeError) {
                  _this.attachmentError(file.name, 'js.attachments.error_total_file_size_per_post');
                } else if (_context.t0 instanceof _AttachmentUploader.FileTypeError) {
                  _this.attachmentError(file.name, 'js.uploader.error_file_type');
                } else {
                  _this.attachmentError(file.name, 'js.uploader.error_on_upload');
                }

                _this.updateAttachments(_this.state.attachments.filter(function (_ref3) {
                  var id = _ref3.attachmentId;
                  return id !== attachmentId;
                }));

                return _context.abrupt("return");

              case 13:
                _this.setState(function (prevState) {
                  return {
                    attachmentToProcess: prevState.attachmentToProcess - 1
                  };
                }, function () {
                  _this.updateAttachments(_this.state.attachments.map(function (a) {
                    if (a.attachmentId !== attachmentId) return a;
                    return Object.assign(a, {
                      url: uploadData.source || uploadData.download_url,
                      source: uploadData.source || uploadData.download_url,
                      source_thumb: uploadData.source_thumb || uploadData.download_url,
                      file_uuid: uploadData.uuid
                    });
                  }));
                });

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 8]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "uploadAttachments", /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(files) {
        var i;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.setState({
                  attachmentToProcess: files.length
                });

                i = 0;

              case 2:
                if (!(i < files.length)) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 5;
                return _this.uploadFile(files[i]);

              case 5:
                i++;
                _context2.next = 2;
                break;

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateAttachments", function (attachments) {
      var _this$state = _this.state,
          imageToProcess = _this$state.imageToProcess,
          attachmentToProcess = _this$state.attachmentToProcess;

      _this.setState({
        attachments: attachments
      });

      if (!_this.props.onChange) return;

      _this.props.onChange(_this.getEditorContent(), (0, _utils.prepareAttachments)(attachments), !!imageToProcess || !!attachmentToProcess);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "deleteAttachment", function (index) {
      _this.updateAttachments(_this.state.attachments.filter(function (_, idx) {
        return idx !== index;
      }));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "submitContent", function (content, attachments, onSubmit) {
      if (_this.props.isGuest) {
        var event = new window.CustomEvent('GuestUserAction');
        return window.dispatchEvent(event);
      }

      onSubmit(content, (0, _utils.prepareAttachments)(attachments), !!_this.state.imageToProcess || !!_this.state.attachmentToProcess);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setNewEditorInstance", function (instance) {
      _this.setState({
        editor: instance
      }, function () {
        _this.state.editor.on('filesToProcessCountChange', function (evt) {
          _this.setState({
            imageToProcess: evt.data.count
          });
        });

        _this.state.editor.on('pollButtonClicked', function () {
          _this.togglePoll();
        });

        if (!_this.props.disableMentions) {
          (0, _observeMentions.observeMentions)();
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "togglePoll", function () {
      var _this$props = _this.props,
          isControl = _this$props.isControl,
          onPollUpdate = _this$props.onPollUpdate;

      _this.setState(function (_ref5) {
        var enablePoll = _ref5.enablePoll;
        return {
          enablePoll: !enablePoll,
          poll: {
            question: '',
            options: []
          }
        };
      });

      if (isControl) onPollUpdate(null);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "editPoll", function (newValue) {
      _this.setState(function (prevState) {
        var newPoll = _objectSpread(_objectSpread({}, prevState.poll), newValue);

        _this.props.onPollUpdate(newPoll);

        return {
          poll: newPoll
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getInitialEditorContent", function () {
      var errors = _this.props.errors;
      var hasErrors = Array.isArray(errors) && errors.length > 0;
      return hasErrors ? null : _this.initialEditorContent;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showNotification", function (category, phrase) {
      _this.setState(function (_ref6) {
        var editorErrors = _ref6.editorErrors;
        return {
          editorErrors: editorErrors.concat({
            category: category,
            phrase: phrase
          })
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onEmojiSelect", function (evt) {
      var emojiCallback = _this.state.emojiCallback;

      if (emojiCallback) {
        return _this.setState({
          emojiCallback: null
        });
      }

      _this.setState({
        emojiCallback: evt.data.onSelect
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onTopicCardClicked", function (evt) {
      var data = evt.data;

      _this.setState({
        showTopicCardModal: true,
        onAddTopic: data.onAdd
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onAdd", function (topic) {
      _this.setState({
        showTopicCardModal: false
      }, function () {
        return _this.state.onAddTopic(topic);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClose", function () {
      _this.setState({
        showTopicCardModal: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDismissError", function () {
      _this.setState({
        attachmentErrors: []
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getCancelButton", function () {
      var _this$props2 = _this.props,
          isControl = _this$props2.isControl,
          onCancel = _this$props2.onCancel,
          cancelPhrase = _this$props2.cancelPhrase;
      return isControl ? (0, _preact.h)(_buttonControl.default, {
        variant: "secondary",
        onClick: function onClick() {
          return onCancel();
        },
        title: (0, _preact.h)(_phrase.default, {
          p: cancelPhrase || 'Cancel'
        })
      }) : (0, _preact.h)(_Button.default, {
        secondary: true,
        link: true,
        onClick: function onClick() {
          return onCancel();
        }
      }, (0, _preact.h)(_phrase.default, {
        p: cancelPhrase || 'Cancel'
      }));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getSubmitButton", function () {
      var _this$props3 = _this.props,
          isControl = _this$props3.isControl,
          btnText = _this$props3.btnText,
          btnPhrase = _this$props3.btnPhrase,
          isLoading = _this$props3.isLoading,
          onCancel = _this$props3.onCancel,
          onSubmit = _this$props3.onSubmit;
      var submitButtonText = btnText || (0, _preact.h)(_phrase.default, {
        p: btnPhrase || 'Send'
      });
      return isControl ? (0, _preact.h)(_buttonControl.default, {
        disabled: isLoading,
        variant: onCancel ? 'success' : 'primary',
        onClick: function onClick() {
          return _this.submitContent(_this.getEditorContent(), _this.state.attachments, onSubmit);
        },
        isLoading: isLoading,
        title: onCancel ? 'Save changes' : submitButtonText
      }) : (0, _preact.h)(_Button.default, {
        primary: true,
        loading: isLoading,
        disabled: isLoading,
        onClick: function onClick() {
          return _this.submitContent(_this.getEditorContent(), _this.state.attachments, onSubmit);
        }
      }, submitButtonText);
    });

    require('../../utils/replaceWithPolyfill');

    require('../../utils/removePolyfill');

    require('../../utils/childNodeBeforePolyfill');

    require('../../utils/parentNodeAppendPolyfill');

    if (props.CKEditor) CKEditor = props.CKEditor;
    _this.initialData = props.data;
    _this.editorContent = props.data;
    _this.initialEditorContent = (0, _contentConverter.toEditorFormat)(props.data);
    _this.editorContent = _this.initialEditorContent;
    _this.attachmentUploader = new _AttachmentUploader.default();
    return _this;
  }

  (0, _createClass2.default)(Editor, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref7) {
      var attachments = _ref7.attachments;
      attachments = attachments || [];
      if (this.state.attachments.length) return;
      this.setState({
        attachments: (0, _utils.prepareAttachmentsForState)(attachments)
      });
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "preloadPhrases",
    value: function preloadPhrases(cb) {
      var noop = function noop() {};

      _utils2.requiredPhrases.forEach(function (_ref8, idx) {
        var _ref9 = (0, _slicedToArray2.default)(_ref8, 2),
            m = _ref9[0],
            p = _ref9[1];

        if (idx === _utils2.requiredPhrases.length - 1) return (0, _phrase.fetchPhrase)(m, p, noop, cb);
        (0, _phrase.fetchPhrase)(m, p, noop);
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.preloadPhrases(function () {
        // eslint-disable-next-line react/no-unused-state
        if (CKEditor) return _this2.setState({
          loaded: true
        });

        require.ensure(['../../libs/ckeditor/ckeditor.js', '../../libs/emoji/selector'], function (require) {
          CKEditor = require('../../libs/ckeditor/ckeditor.js').default;
          EmojiSelector = require('../../libs/emoji/selector').default; // eslint-disable-next-line react/no-unused-state

          _this2.setState({
            loaded: true
          });
        }, 'ckeditor');
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props4 = this.props,
          _this$props4$onChange = _this$props4.onChange,
          _onChange = _this$props4$onChange === void 0 ? function () {} : _this$props4$onChange,
          onCancel = _this$props4.onCancel,
          onSubmit = _this$props4.onSubmit,
          input = _this$props4.input,
          isControl = _this$props4.isControl,
          autoFocus = _this$props4.autoFocus,
          errors = _this$props4.errors,
          cssLink = _this$props4.cssLink,
          disableFileAttachments = _this$props4.disableFileAttachments,
          disableMentions = _this$props4.disableMentions,
          placeholder = _this$props4.placeholder,
          canHavePoll = _this$props4.canHavePoll,
          classes = _this$props4.classes,
          error = _this$props4.error,
          profile = _this$props4.profile,
          permissions = _this$props4.permissions;

      var _ref10 = permissions || {},
          userPermissions = _ref10.permissions;

      var canShowEmbedMedia = isControl ? true : userPermissions.includes('forum.post.embedmedia.upload');
      var editorErrors = this.state.editorErrors;
      var additionalClasses = classes || [];
      return (0, _preact.h)("div", {
        className: "html-editor__wrapper"
      }, (0, _preact.h)(_ErrorList.default, {
        errors: errors
      }), (0, _preact.h)("div", {
        className: _classnames.default.apply(void 0, [{
          'validation-error': error
        }, 'html-editor'].concat((0, _toConsumableArray2.default)(additionalClasses), [isControl && 'html-editor--control']))
      }, (0, _preact.h)(_ErrorList.default, {
        errors: editorErrors.map(function (_ref11) {
          var category = _ref11.category,
              phrase = _ref11.phrase;
          return {
            errorMessage: (0, _preact.h)(_phrase.default, {
              m: category,
              p: phrase,
              count: {
                allowed_files_size: '5MB'
              }
            })
          };
        })
      }), CKEditor && (0, _preact.h)(CKEditor, {
        disableFileAttachments: disableFileAttachments,
        showEmbedMedia: canShowEmbedMedia,
        disableMentions: disableMentions,
        canHavePoll: canHavePoll,
        isControl: isControl,
        autoFocus: autoFocus,
        onInstanceReady: function onInstanceReady(instance) {
          return _this3.setNewEditorInstance(instance);
        },
        data: this.getInitialEditorContent(),
        onFileAttachment: /*#__PURE__*/function () {
          var _ref12 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(evt) {
            return _regenerator.default.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return _this3.uploadAttachments(evt.data.files);

                  case 2:
                    return _context3.abrupt("return", _context3.sent);

                  case 3:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          return function (_x3) {
            return _ref12.apply(this, arguments);
          };
        }(),
        isGuest: this.props.isGuest,
        placeholder: placeholder,
        cssLink: cssLink,
        profile: profile,
        showNotification: this.showNotification,
        onEmojiSelect: this.onEmojiSelect,
        onTopicCardClicked: this.onTopicCardClicked,
        onFocus: function onFocus() {},
        onChange: function onChange(content) {
          content = content.replace(/<oembed(.*)\/>/g, '<oembed$1></oembed>');
          content = (0, _contentConverter.fromEditorFormat)(content);
          content = content.replace(/\n/g, '');
          if (_this3.editorContent && (0, _utils2.compareHtml)(content, _this3.editorContent)) return;

          if (_this3.editorContent !== undefined) {
            _onChange(content, (0, _utils.prepareAttachments)(_this3.state.attachments), !!_this3.state.imageToProcess || !!_this3.state.attachmentToProcess);
          }

          _this3.editorContent = content;
          if (!input) return;
          document.querySelector(input).value = content;
        }
      }), this.state.emojiCallback && EmojiSelector && (0, _preact.h)("div", {
        className: "emoji-selector-positioner-background"
      }), this.state.emojiCallback && EmojiSelector && (0, _preact.h)(_GlobalClick.default, {
        onGlobalClick: function onGlobalClick() {
          _this3.setState({
            emojiCallback: null
          });
        },
        className: "emoji-selector-positioner"
      }, (0, _preact.h)(EmojiSelector, {
        onSelect: function onSelect(unicode, shortname) {
          var emojiCallback = _this3.state.emojiCallback;

          _this3.setState({
            emojiCallback: null
          });

          emojiCallback(unicode, shortname);
        }
      })), this.state.showTopicCardModal && (0, _preact.h)(_AddTopicCardModal.default, {
        isOpen: this.state.showTopicCardModal,
        onAdd: this.onAdd,
        onClose: this.onClose
      })), this.state.enablePoll ? (0, _preact.h)(_Poll.default, (0, _extends2.default)({}, this.state.poll, {
        onDelete: this.togglePoll,
        onChange: function onChange(newValue) {
          return _this3.editPoll(newValue);
        }
      })) : null, (0, _preact.h)(_AttachmentList.default, {
        attachments: this.state.attachments,
        errors: this.state.attachmentErrors,
        onDelete: function onDelete(idx) {
          return _this3.deleteAttachment(idx);
        },
        onDismissError: this.onDismissError
      }), (0, _preact.h)("div", {
        className: "html-editor__buttons"
      }, onSubmit && this.getSubmitButton(), onCancel && this.getCancelButton()));
    }
  }]);
  return Editor;
}(_preact.Component);

var _default = (0, _UserContext.withUserContext)(Editor);

exports.default = _default;